export default {
  newWindow: 'Opent in nieuw venster',
}
